import { BannerVerticalEnum } from "@saleor/types/globalTypes";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Sort,
  TabActionDialog
} from "../types";
import { BannerDetailsPageTab } from "./components/BannerDetailsPage";
// import { SaleDetailsPageTab } from "./components/SaleDetailsPage";

export const discountSection = "/discounts/";

export const bannerSection = urlJoin(discountSection, "banners");
export const bannerListPath = bannerSection;
export enum BannerListUrlFiltersEnum {
  type = "type",
  startedFrom = "startedFrom",
  startedTo = "startedTo",
  status = "status",
  query = "query"
}
export enum BannerListUrlFiltersWithMultipleValues {
  status = "status"
}
export type BannerListUrlFilters = Filters<BannerListUrlFiltersEnum> &
  FiltersWithMultipleValues<BannerListUrlFiltersWithMultipleValues> & {
    verticals?: BannerVerticalEnum[];
  };
export type BannerListUrlDialog = "remove" | "delete" | TabActionDialog;
export enum BannerListUrlSortField {
  name = "name",
  endDate = "end-date",
  startDate = "start-date",
  type = "type",
  value = "value"
}
export type BannerListUrlSort = Sort<BannerListUrlSortField>;
export type BannerListUrlQueryParams = ActiveTab &
  BulkAction &
  Dialog<BannerListUrlDialog> &
  Pagination &
  BannerListUrlFilters &
  BannerListUrlSort & {
    id?: string;
  };
export const bannerListUrl = (params?: BannerListUrlQueryParams) =>
  bannerListPath + "?" + stringifyQs(params);

export const bannerPath = (id: string) => urlJoin(bannerSection, id);
export type BannerUrlDialog =
  | "assign-brand"
  | "assign-category"
  | "assign-collection"
  | "assign-coupon"
  | "assign-coupon-collection"
  | "assign-mall"
  | "assign-product"
  | "assign-store"
  | "unassign-coupon"
  | "unassign-brand"
  | "unassign-collection"
  | "unassign-product"
  | "unassign-store"
  | "delete"
  | "remove";
export type BannerUrlQueryParams = ActiveTab<BannerDetailsPageTab> &
  Pagination &
  BulkAction &
  Dialog<BannerUrlDialog>;
// &
// ActiveTab<SaleDetailsPageTab>;
export const bannerUrl = (id: string, params?: BannerUrlQueryParams) =>
  bannerPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const bannerAddPath = urlJoin(bannerSection, "add");
export const bannerAddUrl = bannerAddPath;

export const bannerCreateTabUrl = (params: BannerUrlQueryParams) =>
  bannerAddUrl + "?" + stringifyQs(params);
